<template>
  <el-dialog :class="[currentTheme]" :title="dialogName" :visible.sync="clientDialogVisible" :close-on-click-modal="false"  :modal-append-to-body="true" :append-to-body="true" width="60%">

  <div class="main-box">
       <el-table
         :data="tableData"
         stripe
         border
         height="600"
         style="width: 100%">
         <el-table-column
           type="index"
           label="序号"
           align="center"
           width="50">
         </el-table-column>
         <el-table-column
           prop="name"
           label="资源名称"
           width="200">
<!--           <template  slot-scope="scope">-->
<!--             <a class="info-a" href="#" @click.prevent="download(scope.row.downloadUrl)">{{scope.row.name}}</a>-->
<!--           </template>-->
         </el-table-column>
         <el-table-column
           prop="remarks"
           label="描述">
         </el-table-column>
         <el-table-column
           label="文件"
           width="350">
           <template  slot-scope="scope">
             <a class="info-a" href="#" @click.prevent="download(scope.row.downloadUrl)">{{scope.row.sourceName}}</a>
           </template>
         </el-table-column>
       </el-table>
    </div>
  </el-dialog>
</template>

<script>


  export default {

    name: 'down-list',
    data() {
      return {
        dialogName: '资源中心',
        clientDialogVisible: false,
        tableData:[
          {
            name:  '家医签约手写板插件(汉王友基)',
            sourceName:  'web_nsv_1.0.6.11_setup_cn_u010.exe',
            downloadUrl: process.env.WEB_URL + '/download/install/web_nsv_1.0.6.11_setup_cn_u010.exe',
            remarks: '用于家医签约手写板的插件',
          },
          {
            name:  '家医签约手写板插件(爱依克)',
            sourceName:  'SignServiceSetup_2.0.7.exe',
            downloadUrl: process.env.WEB_URL + '/download/install/SignServiceSetup_2.0.7.exe',
            remarks: '用于家医签约手写板的插件',
          },
          {
            name:  '谷歌浏览器安装包（win10及以上）',
            sourceName:  '142.0.7444.163_chrome_installer.exe',
            downloadUrl: process.env.WEB_URL + '/download/install/142.0.7444.163_chrome_installer.exe',
            remarks: '谷歌浏览器（win10及以上）',
          },
          {
            name:  'win7能用的google阅览器安装包',
            sourceName:  'win7_chrome.zip',
            downloadUrl: process.env.WEB_URL + '/win7_chrome.zip',
            remarks: '谷歌浏览器（win7可用）',
          }
        ],
      }
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    components: {
    },
    created(){

    },

    // 初始化
    methods: {
      init(){
        this.clientDialogVisible = true;
      },
      //下载
      download(url) {
        const link = document.createElement('a');
        link.href = url;
        link.download = url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    }
  }
</script>
<style scoped>



</style>




// WEBPACK FOOTER //
// src/views/common/Down-list.vue